import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { MachineSelectorPluginService } from './machineselector-plugin.service';
import { MachineFamillyService, InspectionModelService, ApplicationService } from '../../shared/services';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Inspection } from '../../shared/models/index';
import * as _ from 'lodash';

@Component({
    selector: 'categories-edit',
    templateUrl: './categories-edit.component.html',
    standalone: false
})
export class CategoriesEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  inspectionId: string;
  productLineId: string;
  categoryId: string;

  categoriesForm: UntypedFormGroup;
  productLines: any[];
  categories: any[];
  categoriesComboData: any[];
  machines: any[];
  machinesComboData: any[];
  isOptimization: boolean;
  public processing = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: MachineSelectorPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private machineFamillyService: MachineFamillyService,
    private inspectionModelService: InspectionModelService,
    private applicationService: ApplicationService
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      this.initData();
    });
  }

  public initData() {
    this.machineFamillyService.getProductLines().subscribe((data) => {
      this.productLines = data;
    });

    this.machineFamillyService.getCategories().subscribe((data) => {
      this.categories = data;
    });

    this.machineFamillyService.getModels().subscribe((data) => {
      this.machines = data;
    });

    this.inspectionModelService.getModel(this.inspectionId).subscribe((el) => {
      this.applicationService.isOptimization().subscribe((data) => {
        const category = el.categories[0];
        this.isOptimization = data;
        if (category) {
          this.productLineId = category.ProductLineId;
          this.categoryId = category.CategoryId;
        }
        this.initForm();
      });
    });
    this.cdRef.detectChanges();
  }

  public showMachineFamilySelector(): boolean {
    return this.categoriesForm ? this.categoriesForm.controls['productLineId'].value !== '' : false;
  }

  public showMachines(): boolean {
    if (this.isOptimization) {
      return this.categoriesForm ? this.categoriesForm.controls['productLineId'].value !== '' : false;
    } else {
      return this.categoriesForm ? this.categoriesForm.controls['categoryId'].value !== '' : false;
    }
  }

  initForm() {
    if (this.isOptimization) {
      this.categoriesForm = new UntypedFormGroup({
        productLineId: new UntypedFormControl(this.productLineId)
      });
    } else {
      this.categoriesForm = new UntypedFormGroup({
        productLineId: new UntypedFormControl(this.productLineId),
        categoryId: new UntypedFormControl(this.categoryId)
      });
    }
    this.updateCategories();
    this.updateMachines();
  }

  updateCategories() {
    if (this.isOptimization) {
      const productLineId = this.categoriesForm.controls['productLineId'].value;
      this.categoriesComboData = _.filter(this.categories, ['productLineId', productLineId]);

      this.machinesComboData = _.filter(
        this.machines,
        (m: any) => !m.hidden && _.find(this.categoriesComboData, (c: any) => c.id === m.categoryId) !== undefined
      );
    } else {
      const productLineId = this.categoriesForm.controls['productLineId'].value;
      this.categoriesComboData = _.filter(this.categories, ['productLineId', productLineId]);
    }
  }

  updateMachines() {
    if (!this.isOptimization) {
      const categoryId = this.categoriesForm.controls['categoryId'].value;

      this.machinesComboData = _.filter(this.machines, (m: any) => !m.hidden && categoryId === m.categoryId);
    }
  }

  save(model: any) {
    this.processing = true;
    this.service.updateCategories(this.inspectionId, [model]).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }
}
